module.exports = __webpack_public_path__ + "./img/Oferta-Tiempo.c0c7c6d476369118c8dd0dd67aea014a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Oferta-Tiempo.png
// module id = ./src/assets/img/Oferta-Tiempo.png
// module chunks = 6